import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import MapView from '../components/lifelink/MapView';
import RequestCard from '../components/lifelink/RequestCard';
import { Map } from 'lucide-react';
import axios from 'axios';
import useSEO from '../hooks/useSEO';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MapPage() {
  const { t } = useLanguage();
  useSEO({
    title: 'Mappa Emergenze',
    description: 'Visualizza tutte le emergenze attive su mappa interattiva Leaflet con geolocalizzazione GPS. Filtra per categoria, priorità e stato in tempo reale.',
    keywords: 'mappa emergenze, leaflet, geolocalizzazione, mappa protezione civile, emergenze live',
  });
  const [requests, setRequests] = useState([]);
  const [selectedReq, setSelectedReq] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get(`${API}/requests`, { params: { limit: 100 } });
        setRequests(data.requests || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  const geoRequests = requests.filter(r => r.latitudine && r.longitudine);

  return (
    <div className="min-h-screen bg-[#E8F4FD] pt-20 pb-8" data-testid="map-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-6">
          <Map size={20} className="text-[#FF3B30]" />
          <h1 className="font-['Barlow_Condensed'] text-2xl sm:text-3xl font-black uppercase tracking-tight text-[#0D1B2A]">
            {t('mappa_live')}
          </h1>
          <span className="text-xs font-mono text-[#6B8AB5] uppercase tracking-widest">
            {geoRequests.length} segnalazioni
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <MapView
              requests={geoRequests}
              height="calc(100vh - 160px)"
              onMarkerClick={(req) => setSelectedReq(req)}
            />
          </div>
          <div className="space-y-3 max-h-[calc(100vh-160px)] overflow-y-auto">
            <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-[#4A6B8A] sticky top-0 bg-[#E8F4FD] py-2">
              {t('richieste_recenti')} ({geoRequests.length})
            </h2>
            {loading ? (
              <div className="text-center py-12 text-[#6B8AB5] text-sm">{t('caricamento')}</div>
            ) : geoRequests.length === 0 ? (
              <div className="text-center py-12 text-[#6B8AB5] text-sm border border-[#B8D4E8] bg-white">
                Nessuna segnalazione con posizione GPS
              </div>
            ) : (
              geoRequests.map(req => (
                <RequestCard
                  key={req.id}
                  request={req}
                  onClick={() => setSelectedReq(req)}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
